import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/16/solid';

export default function PlotModal({
  children,
  toggleOpen,
  openImagePopup,
  hasImages,
  currentSlideIndex = 0,
}) {
  return (
    <Modal
      isOpen={true}
      onClose={() => toggleOpen(false)}
      size={{ base: 'xs' }}
    >
      <ModalOverlay />

      <ModalContent>
        {hasImages && (
          <Button
            variant={'solid'}
            position={'absolute'}
            top={3}
            p={3}
            bg={'primary.bg.default'}
            rounded={'full'}
            onClick={() => openImagePopup(currentSlideIndex ?? 0)}
            zIndex={2}
            style={{
              right: '3.8rem',
            }}
          >
            <MagnifyingGlassIcon width={16} height={16} />
          </Button>
        )}
        <ModalCloseButton
          variant={'solid'}
          backgroundColor={'primary.bg.default'}
          borderRadius={'full'}
          right={3}
          top={3}
          p={5}
          color={'primary.txt'}
          transition="color 0.15s ease-out, background 0.15s ease-out, border 0.15s ease-out"
          _hover={{
            bg: 'primary.bg.darker',
          }}
          _active={{
            bg: 'primary.bg.darkest',
          }}
          _focus={{
            bg: 'primary.bg.darker',
          }}
          zIndex={1}
        />
        <ModalBody p={0}>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
}

PlotModal.propTypes = {
  children: PropTypes.node.isRequired,
  toggleOpen: PropTypes.func.isRequired,
  openImagePopup: PropTypes.func.isRequired,
  hasImages: PropTypes.bool,
  currentSlideIndex: PropTypes.number,
};
